<template>
  <HdModal v-if="isVisible" class="homeday-maximum-price-modal" @close="noop">
    <template #title>
      {{ $t('WIZARD.HOMEDAY_MAXIMUM_PRICE.TITLE') }}
    </template>
    <template #body>
      <p
        class="homeday-maximum-price-modal__text"
        v-html="$t('WIZARD.HOMEDAY_MAXIMUM_PRICE.TEXT', { goldstandard: formattedPrice })"
      />
    </template>
    <template #footer>
      <HdButton
        modifier="primary"
        class="homeday-maximum-price-modal__button"
        data-testid="homeday-maximum-price-modal-acknowledge"
        :disabled="isAcknowledging"
        @click="onAcknowledge"
      >
        {{ $t('WIZARD.HOMEDAY_MAXIMUM_PRICE.ACKNOWLEDGE') }}
      </HdButton>
    </template>
  </HdModal>
</template>

<script>
import { HdModal, HdButton } from 'homeday-blocks';
import { formatPrice } from '@/services/formatters';

export default {
  name: 'HomedayMaximumPriceModal',
  components: {
    HdModal,
    HdButton,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    homedayMaximumPrice: {
      type: Number,
      required: true,
    },
    isAcknowledging: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    formattedPrice() {
      return formatPrice(this.homedayMaximumPrice, { fractionDigits: 0 });
    },
  },
  methods: {
    noop() {},
    onAcknowledge() {
      this.$emit('acknowledge');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/mixins.scss';

.homeday-maximum-price-modal {
  &__text {
    @include font('DS-100');
    margin: 0;
  }

  &__button {
    width: 100%;

    @include for('tablet') {
      width: auto;
    }
  }
}
</style>

<style lang="scss">
.homeday-maximum-price-modal {
  .hd-modal__close,
  .hd-modal__close-button,
  button[aria-label='Close'],
  button[aria-label='Schließen'] {
    display: none !important;
  }
}

// The price markup is injected via v-html from the translation message, so it
// does not carry the component's scoped attribute and must be styled globally.
.homeday-maximum-price-modal__price {
  font-weight: 700;
}
</style>
